import './MainContentAreaAll.css';
import { Link } from 'react-router-dom';
function LabCorpJobComponent(props){ 
    return(
       <div className="ExperienceMainLayout">   
       <br /> 
        <div class="card">
           <div class="card-footer" style={{height:"50px"}}>
            <span className="ExperienceCardFooter-Previous"><Link onClick={() => props.handlechange('AtT')}>Previous</Link></span>
            <span className="ExperienceCardFooter"><Link onClick={() => props.handlechange('SelfProject')}>Next</Link></span>
           </div>
           <h5 class="card-header">
                              Labcorp, Raleigh, NC		
                              <br/>Jan 2016 – Apr 2017
                              <br/>Full Stack.Net Developer
           </h5>    					       
           <div class="card-body">
            <h3 style={{textDecoration:"underline"}}>Roles And Responsibilities</h3>
            -Redesigned the existing application using ASP.NET MVC Framework, C#, HTML5/CSS3 and Entity framework.
          <br />-The front-end features were redesigned using Angular, HTML, CSS, Bootstrap.
          <br />-The back-end technology was upgraded to ASP.NET MVC 5 Framework and SQL server 2016.
          <br />-Created Domain Objects (Models) in MVC 5 by using Entity Framework 6 Database First Approach.
          <br />-Created Send Email Task follow Data Flow Task to send notification emails to users who have subscribed for the event.
          <br />-Designed and customized MVC and Web API route to integrate.NET Framework and Single page application (SPA) that is created by using Angular.
          <br />-Created Angular Services and made it custom, self-contained, reusable, and testable to retrieve/add/update/delete data from Web API through HTTP GET/ POST/ PUT/ DELETE by using Angular/cli and Dependency Injection to components.
          <br />-Used LINQ queries and lambda expressions to perform operations against the database using Entity Framework 6.
          <br />-Effectively created/modified tables on SQL server.
          <br />-Modified and developed several complex stored procedures and used Triggers for alert purposes.
          <br />-Used Team Foundation Server (TFS) for source version control on a shared team environment.

          
            <h3 style={{textDecoration:"underline"}}>Environment</h3>
            Visual Studio 2015/2013,.NET Framework 4.5, Entity Framework 6.0, ASP.NET MVC 5, C#, Angular 2.0, JavaScript, HTML 5, CSS 3, SQL, Microsoft SQL server, Microsoft SQL server management studio, Bootstrap 4.0
           </div>            
         </div>
       </div>
       
)
}
export default LabCorpJobComponent